import { NgModule, isDevMode, LOCALE_ID } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";
import { registerLocaleData } from "@angular/common";
import localeZhHans from "@angular/common/locales/zh-Hans";
import localeZhHK from "@angular/common/locales/zh-Hans-HK";
import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { JWTInterceptor } from "./interceptors/jwt.interceptor";
import { RauchprotokollComponent } from "./rauchprotokoll/rauchprotokoll.component";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "../environments/environment";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TimeoutInterceptor } from "./interceptors/timeout.interceptor";
import { AppVersion } from "@awesome-cordova-plugins/app-version/ngx";
import { CigarselectorComponent } from "./cigarselector/cigarselector.component";
import { SharedModule } from "./shared.module";

@NgModule({
  declarations: [AppComponent, RauchprotokollComponent, CigarselectorComponent],
  imports: [
    SharedModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule.forRoot({
      rippleEffect: false,
      mode: "md",
      innerHTMLTemplatesEnabled: true,
    }),
    AppRoutingModule,
    HttpClientModule,
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: "registerWhenStable:30000",
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: "registerWhenStable:30000",
    }),
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    AppVersion,
    { provide: HTTP_INTERCEPTORS, useClass: JWTInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: "zh-Hans" }, // oder 'zh-Hans-CN'
    { provide: LOCALE_ID, useValue: "zh-Hans-HK" },
  ],
  bootstrap: [AppComponent],
  exports: [TranslateModule, FormsModule, ReactiveFormsModule, IonicModule],
})
export class AppModule {
  constructor() {
    registerLocaleData(localeZhHans);
    registerLocaleData(localeZhHK);
  }
}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
